import type fr from "./schema_fr";

const en: typeof fr = {
  "schema.column": (actual: string, expected: string) =>
    `${actual} is not an expected value for the "column" field. Possible options are ${expected}.`,
  "schema.block.position": `Values specified in the "position" section must be positive integers.`,
  "schema.block.kind": `The block type specified in the "kind" field is not supported. Possible options are "TEXT", "HEADING", "PLOT", "COMMENT".`,
  "schema.identifier": "Identifier must contain only letters, numbers, and underscores.",
  "schema.layer.mark": (actual: string, expected: string) =>
    `${actual} is not an expected value for the "mark" field. Possible options are ${expected}.`,
  "schema.layer.zoom": `The values specified for the "min" and "max" fields in the "zoom" section must be numeric or dates formatted as yyyy-mm-ddThh:mm:ss.sssZ (ex. 2000-01-01T00:00:00.000Z).`,
  "schema.layer.zoom.gt": (min: string | number | null, max: string | number | null) =>
    `The "min" value must be less than the "max" value in the "zoom" section (${min} > ${max}).`,
  "schema.layer.rule": `The values specified in the "value" field in the "rule" section must be numeric or dates formatted as yyyy-mm-ddThh:mm:ss.sssZ (ex. 2000-01-01T00:00:00.000Z).`,
  "schema.period": (expected: string) =>
    `Values specified for the "period" field must be durations in ISO8601 format. Other allowed values are ${expected}.`,
  "schema.layer.position": `The value specified in the "layer.position" field must be "left" or "right".`,
  "schema.resource.identifier.unavailable": (actual: string) =>
    `The identifier ${actual} specified in the "resource.identifier" field does not exist in the project.`,
  "schema.layer.encoding": (identifier: string, column: string) =>
    `The pair (${identifier}, ${column}) is not defined as a resource in the "data" section.`,
};

export default en;
